import React from "react";
import { ApiApplication } from "@/model/interface/api/ApiApplication";
import { useNavigate } from "react-router-dom";
import { getUrlStepFromApplicationStep } from "@/util/url-utils";
import { ArrowRight, ClipboardList } from "lucide-react";

interface ExistingApplicationProps {
  applications: ApiApplication[];
  type: string;
}

const ExistingApplications = ({ applications, type }: ExistingApplicationProps) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 rounded-xl bg-[#9BFBE0]/15 px-5 py-4">
        <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-[#9BFBE0]/40">
          <ClipboardList className="size-5 text-[#010305]" />
        </div>
        <div>
          <p className="text-base font-semibold text-gray-900">Welcome back!</p>
          <p className="text-sm text-gray-600">
            You have <strong className="text-gray-900">{applications.length}</strong> {type} application
            {applications.length > 1 ? "s" : ""} ready to continue. Pick up right where you left off?
          </p>
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Created
              </th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {applications.map((application) => (
              <tr
                key={application.id}
                className="hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() =>
                  navigate(`/application/${application.id}/${getUrlStepFromApplicationStep(application.step)}`)
                }
              >
                <td className="px-4 py-3 text-sm text-gray-900 font-medium">{application.id}</td>
                <td className="px-4 py-3 text-sm text-gray-600">{application.createdAt}</td>
                <td className="px-4 py-3 text-right">
                  <button className="inline-flex items-center gap-1.5 rounded-full bg-[#9BFBE0] px-5 py-2 text-xs font-medium text-[#010305] shadow-sm hover:shadow-md transition-all cursor-pointer">
                    Continue
                    <ArrowRight className="size-3.5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExistingApplications;
